import { combineReducers } from 'redux';
import { merge } from 'lodash';
import facilityListReducer from './list/reducer';
import { facilityItemReducer } from './wizard/reducer';
import {
  facilityRevolvingTypesReducer,
  facilityFlexibilityRulesReducer,
  facilityCreditLineStatusesReducer,
  facilityPurposesForApplicationReducer,
  facilityPartnerGroupsReducer,
  transferFacilityToERPPermissionsReducer,
  facilityWarrantiesReducer
} from './edit/generalData/reducers/reducer';
import {
  facilitySublimitsReducer,
  facilitySublimitFiltersReducer,
  facilitySublimitFinancingStructureFiltersReducer
} from './edit/sublimits/reducers/reducer';
import { facilityKpiIndicatorsReducer } from './edit/kpiIndicators/kpiIndicators/reducers/reducer';
import facilityNextStatesReducer from './edit/states/reducer';
import { TRANSFER_FACILITY_TO_ERP_EXECUTED } from './edit/generalData/eventTypes';
import { FACILITY_STATE_UPDATED } from './edit/states/eventTypes';

import {
  UPDATE_FACILITY_SUBLIMIT_FILTERS_SUCCEEDED,
  UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_SUCCEEDED
} from './edit/sublimits/actionTypes';
import {
  FACILITY_SUBLIMIT_SAVED
  
} from './edit/sublimits/eventTypes';
import initialState from 'reducers/initialState';

const entitiesReducer = (state = initialState.facilities.entities, action) => {
  if (action.entitiesCategory && action.entitiesCategory === 'facilities' && action.entities) {
    return merge({}, state, action.entities);
  }

  switch (action.type) {
    case TRANSFER_FACILITY_TO_ERP_EXECUTED: {
      const { documentId, chDocumentId, chDocumentSiteId } = action.event.eventBody;

      let result = {
        ...state,
        facilities: { ...state.facilities }
      };

      result.facilities[documentId] = {
        ...result.facilities[documentId],
        chDocumentId: chDocumentId,
        chDocumentSiteId: chDocumentSiteId
      };

      return result;
    }

    case FACILITY_STATE_UPDATED: {
      return {
        ...state,
        facilities: {
          ...state.facilities,
          [action.event.eventBody.documentId]: {
            ...state.facilities[action.event.eventBody.documentId],
            documentStateId: action.event.eventBody.stateId,
            documentStateCode: action.event.eventBody.stateCode,
            documentStateName: action.event.eventBody.stateName
          }
        }
      };
    }

    case UPDATE_FACILITY_SUBLIMIT_FILTERS_SUCCEEDED: {
      const { sublimitId, condition, filters } = action;

      const sublimitFilters = {};
      filters.forEach(filter => {
        sublimitFilters[filter.filterId] = filter;
      });

      return {
        ...state,
        facilitySublimits: {
          ...state.facilitySublimits,
          [sublimitId]: {
            ...state.facilitySublimits[sublimitId],
            condition
          }
        },
        facilitySublimitFilters: {
          ...state.facilitySublimitFilters,
          ...sublimitFilters
        }
      };
    }

    case UPDATE_FACILITY_SUBLIMIT_FINANCING_STRUCTURE_FILTERS_SUCCEEDED: {
      const { sublimitId, condition, filters } = action;

      const sublimitFinancingStructureFilters = {};
      filters.forEach(filter => {
        sublimitFinancingStructureFilters[filter.filterId] = filter;
      });

      return {
        ...state,
        facilitySublimits: {
          ...state.facilitySublimits,
          [sublimitId]: {
            ...state.facilitySublimits[sublimitId],
            financingStructureCondition: condition
          }
        },
        facilitySublimitFinancingStructureFilters: {
          ...state.facilitySublimitFinancingStructureFilters,
          ...sublimitFinancingStructureFilters
        }
      };
    }

    case FACILITY_SUBLIMIT_SAVED: {
      const { sublimitId, item } = action.event.eventBody;
      let result = {
        ...state,
        facilitySublimits: { ...state.facilitySublimits }
      };

      result.facilitySublimits[sublimitId] = {
        ...result.facilitySublimits[sublimitId],
        ...item,
        sublimitId: sublimitId
      };

      return result;
    }

    default:
      return state;
  }
};

const combinedReducer = combineReducers({
  entities: entitiesReducer,
  list: facilityListReducer,
  item: facilityItemReducer,
  facilityRevolvingTypes: facilityRevolvingTypesReducer,
  facilityFlexibilityRules: facilityFlexibilityRulesReducer,
  facilityCreditLineStatuses: facilityCreditLineStatusesReducer,
  facilityPurposesForApplication: facilityPurposesForApplicationReducer,
  facilityPartnerGroups: facilityPartnerGroupsReducer,
  facilitySublimits: facilitySublimitsReducer,
  facilitySublimitFilters: facilitySublimitFiltersReducer,
  facilitySublimitFinancingStructureFilters: facilitySublimitFinancingStructureFiltersReducer,
  facilityNextStates: facilityNextStatesReducer,
  facilityKpiIndicators: facilityKpiIndicatorsReducer,
  transferFacilityToERPPermissions: transferFacilityToERPPermissionsReducer,
  facilityWarranties: facilityWarrantiesReducer
});

const exp = (state, action) => combinedReducer(state, action);
export default exp;
